import * as React from "react"
import { Link } from "react-router-dom"
import request from "@/server/request"
import config from "@/server/config"
import * as utils from "@/server/utils"

const Toast = require("react-toast-mobile")

export default class Integral extends React.Component<any, any> {
  constructor(props: any) {
    super(props)
    this.state = {
      memberId: utils.getQueryString("mid") || "", // 会员id
      ruleShow: false,
      totalScore: 0, // 积分
      signData: {
        signList: [],
      }, // 签到信息
      taskList: [], // 任务列表
      userInfo: null, // 检测专家
      companyInfo: null, // 检测企业认证
      companyAuth: 1, // 企业认证状态
      isOpenStore: false, // 是否开通店铺
      taskBlackList: ["00_04_00_002", "00_01_00_007", "00_02_00_002"], // 任务黑名单
      isWechat: utils.getIsWxClient(),
    }
  }

  public render() {
    return (
      <div className="integral">
        <div className="integral-panel">
          <div className="integral-panelc">
            <Link to={"/integral/detail?mid=" + this.state.memberId}>
              查看积分收支明细
            </Link>
            <p>
              本年总积分<strong>{this.state.totalScore}</strong>
            </p>
          </div>
          <img src={require("../../../assets/images/integral1.png")} />
        </div>
        <dl className="integral-sign">
          <dt>
            每日签到送积分
            <img
              onClick={() => this.ruleShow(true)}
              src={require("../../../assets/images/icon-why.png")}
            />
          </dt>
        </dl>
        <div className="integral-date">
          <ul>
            {this.state.signData.signList.map((v: any, k: number) => {
              return (
                <li className={v.sign ? "active" : ""} key={k}>
                  {v.sign ? (
                    <img
                      src={
                        v.today
                          ? require("../../../assets/images/icon-right.png")
                          : require("../../../assets/images/icon-right2.png")
                      }
                    />
                  ) : null}
                  <strong>{v.day}</strong>
                  <p>{v.month}月</p>
                </li>
              )
            })}
          </ul>
          <p className="integral-sign-text">
            您已连续签到：<label>{this.state.signData.continueDay}</label>天，
            <label>再签到{this.state.signData.cycleNext}天获得积分奖励</label>
          </p>
          <button
            className={
              this.state.signData.todaySign
                ? "integral-sign-btn disabled"
                : "integral-sign-btn"
            }
            onClick={() => this.runTask("00_01_00_003")}
          >
            签到
          </button>
        </div>
        <dl className="integral-sign">
          <dt>做任务</dt>
        </dl>
        <ul className="integral-task">
          {this.state.taskList.map((v: any) => {
            return this.state.taskBlackList.indexOf(v.code) === -1 ? (
              <li className={v.finish ? "" : "v1"} key={v.code}>
                <div className="integral-taskl">
                  <strong>{v.name}</strong>
                  <p>{v.explain}</p>
                  <p>{"积分+" + v.score}</p>
                </div>
                <div className="integral-taskr">
                  {v.finish ? (
                    <span>已完成</span>
                  ) : (
                    <a
                      href="javascript: void(0);"
                      onClick={() => this.runTask(v.code)}
                    >
                      去完成
                    </a>
                  )}
                </div>
              </li>
            ) : null
          })}
        </ul>
        {this.state.ruleVisible ? (
          <div className="integral-rule">
            <div className="integral-rulec">
              <h5>签到规则</h5>
              <p>①每个用户每天可签到一次，每日签到增加5积分；</p>
              <p>
                ②连续签到以7天为一周期，每新增一周期，周期内的日积分将在上一周期的日积分的基础上新增5积分奖励；如，连续签到1-7天，每日签到积分为5分，第8-14天，每日签到积分为10分，以此类推；
              </p>
              <p>③当签到中断后，积分不清零，但将重新统计签到天数。</p>
            </div>
            <img
              onClick={() => this.ruleShow(false)}
              className="integral-rule-close"
              src={require("../../../assets/images/icon-close.png")}
            />
          </div>
        ) : null}
      </div>
    )
  }

  public componentDidMount() {
    // 获取积分
    this.getIntegral()
    // 获取任务列表
    this.getTasks()

    // 检查是否是专家
    this.checkExpert()
    // 检查企业认证状态
    this.checkEnterprise()
  }

  // 获取积分
  private async getIntegral() {
    const r = await request({
      url: `${config.COMPONENT_API}score/account/info`,
      method: "post",
      data: JSON.stringify({
        memberId: this.state.memberId,
      }),
      headers: {
        "Content-Type": "application/json",
      },
    })

    if (r.code === 1) {
      this.setState({
        signData: r.obj.scoreSignVo,
        totalScore: r.obj.yearScore,
      })
    }
  }

  /**
   * [ruleShow 显示隐藏规则]
   * @param  {[boolean]} visible
   * @return null
   */
  private ruleShow(visible: boolean) {
    this.setState({
      ruleVisible: visible,
    })
  }

  private async getTasks() {
    const r = await request(
      {
        url: `${config.COMPONENT_API}score/task/list`,
        method: "post",
        data: {
          memberId: this.state.memberId,
        },
        headers: {
          "Content-Type": "application/json",
        },
      },
      true
    )

    if (r.code === 1) {
      this.setState({
        taskList: r.obj,
      })
    }
  }

  /**
   * [runTask 完成任务]
   * @param {string} code 任务码
   * @return null
   */
  private runTask(code: string) {
    const that = this
    let [
      task_01_001,
      task_04_002,
      task_01_003,
      task_04_003,
      task_03_003,
      task_03_002,
      task_01_009,
      task_04_005,
      task_01_006,
      task_01_008,
      task_02_001,
      login,
    ] = [
      "/userInfo",
      "/store/information",
      "",
      "",
      "",
      "/u/",
      "",
      "/store/commodityMangement/release",
      "",
      "",
      "",
      "/login?returnUrl=",
    ]
    if (config.ENV === "production") {
      task_01_003 = "https://m.ibuychem.com"
      task_04_003 = "https://m.cn.ibuychem.com/"
      task_03_003 = "https://mu.ibuychem.com/#/"
      task_01_009 = "https://m.ibuychem.com/buy/supplyBuyOnline.htm"
      task_01_006 = "https://m.hzeyun.com/zb"
      task_02_001 = "https://m.hzeyun.com/"
      task_01_008 = "https://m.ibuychem.com/courses/"
    } else {
      task_01_003 = "https://m-stg.ibuychem.com"
      task_04_003 = "https://m.cn-stg.ibuychem.com"
      task_03_003 = "https://mudev.ibuychem.com/#/"
      task_01_009 = "https://m-stg.ibuychem.com/buy/supplyBuyOnline.htm"
      task_01_006 = "https://m-stg.hzeyun.com/zb"
      task_02_001 = "https://m-stg.hzeyun.com/"
      task_01_008 = "https://m-stg.ibuychem.com/courses/"
    }
    const run = {
      // 个人认证
      "00_01_00_001": function () {
        that.props.history.push(task_01_001)
      },
      // 企业认证
      "00_01_00_002": function () {
        that.startTaskEnterprise()
      },
      // 完成店铺信息填写
      "00_04_00_001": function () {
        that.startTaskStoreInfo(task_04_002)
      },
      // 签到
      "00_01_00_003": function () {
        that.startTaskSign()
      },
      // 分享
      "00_01_00_004": function () {
        if (!that.state.isWechat) {
          return Toast.T.notify("请在微信打开任务")
        }
        window.location.href = task_01_003
      },
      // 分享店铺
      "00_04_00_003": function () {
        if (!that.state.isWechat) {
          return Toast.T.notify("请在微信打开任务")
        }
        window.location.href = task_04_003
      },
      // 商品购买
      "00_01_00_010": function () {
        window.location.href = task_04_003
      },
      // 成为专家
      "00_01_00_005": function () {
        that.startTaskExpert()
      },
      // 浏览文章
      "00_02_00_001": function () {
        window.location.href = task_02_001
      },
      // 浏览直播
      "00_01_00_006": function () {
        window.location.href = task_01_006
      },
      // 浏览课程
      "00_01_00_008": function () {
        window.location.href = task_01_008
      },
      // 发布商品
      "00_04_00_005": function () {
        const companyInfo = that.state.companyInfo
        if (!companyInfo) {
          Toast.T.notify("请先完成企业认证")
          return
        }
        that.props.history.push({
          pathname: task_04_005,
          state: { companyId: that.state.userInfo.companyId },
        })
      },
      // 发布求购
      "00_01_00_009": function () {
        that.checkLogin(function (r: any) {
          if (r.code !== 100) {
            window.location.href = task_01_009
          } else {
            window.location.href = login + encodeURIComponent(task_01_009)
          }
        })
      },
      // 发布优料库商品
      "00_03_00_002": function () {
        that.props.history.push({ pathname: task_03_002 })
      },
      // 查看商品
      "00_04_00_004": function () {
        window.location.href = task_04_003
      },
      // 浏览优料库商品
      "00_03_00_001": function () {
        window.location.href = task_03_003
      },
      // 申请使用商品 - 商铺索取小样
      "00_04_00_006": function () {
        window.location.href = task_01_003
      },
      // 优料库索取小样
      "00_03_00_003": function () {
        window.location.href = task_01_003
      },
    }

    run[code] && run[code]()
  }

  // 检测是否是专家
  private async checkExpert() {
    const r = await request({
      method: "get",
      url: `${config.WAPAPI}safety/account/get`,
      data: {
        queryType: 1,
      },
    })

    if (r.code === 1) {
      this.setState({
        userInfo: r.obj,
      })
    }
  }

  // 检测企业认证
  private async checkEnterprise() {
    const r = await request({
      method: "get",
      url: `${config.CE}member/company/info`,
    })

    if (r.code === 1) {
      this.setState({
        companyAuth: r.obj.authStatus,
        companyInfo: r.obj.companyInfo,
      })
      // 查询店铺
      this.checkStoreInfo(r.obj.companyInfo ? r.obj.companyInfo.id : "")
    }
  }

  // 签到
  private startTaskSign() {
    if (this.state.signData.todaySign) {
      return
    }

    const that = this

    ;(window as any).integral.sign({
      env: config.ENV !== "production" ? "dev" : "pro",
      code: "00_01_00_003",
      entityId: "",
      entityType: "",
      callback: function () {
        that.getIntegral()
        that.getTasks()
      },
    })
  }

  // 执行专家任务
  private startTaskExpert() {
    const expert = this.state.userInfo.expert
    let path = ""
    if (expert) {
      if (expert.auditStatus === 1) {
        path = "/expert/home"
      } else {
        path = "/expert"
      }
    } else {
      path = "/expert"
    }
    this.props.history.push(path)
  }

  // 执行企业认证任务
  private startTaskEnterprise() {
    const companyInfo = this.state.companyInfo
    if (!companyInfo) {
      ;(this.props as any).history.push("/auth/component")
      return
    }

    if (companyInfo && companyInfo.applyRecode) {
      const type = companyInfo.applyRecode.type
      const status = companyInfo.applyRecode.status
      const refuseReason = companyInfo.applyRecode.refuseReason

      if (type === 0 || type === 1) {
        if (status === 0 || status === 2) {
          // 待审核
          ;(this.props as any).history.push(
            `/auth/status?status=${status}&refuseReason=${
              status === 2 ? refuseReason : ""
            }`
          )
          return
        } else if (status === 1) {
          // 通过
          ;(this.props as any).history.push("/authentication/enterprise")
          return
        } else if (status === -1) {
          // 通过
          ;(this.props as any).history.push("/auth/component")
          return
        }
      }
    }
    ;(this.props as any).history.push("/authentication/enterprise")
  }

  /**
   * [startTaskStoreInfo 店铺信息]
   * @param {[string]} path? [路径]
   * @return null
   */
  private startTaskStoreInfo(path?: string) {
    if (this.state.companyAuth > 2 && this.state.companyAuth < 6) {
      // 如果是子账号
      if (this.state.companyAuth === 4) {
        return Toast.T.notify("您的账号不是企业主账号，无法完成该任务")
      }
      // 查看是否开通了店铺
      if (!this.state.isOpenStore) {
        return Toast.T.notify(
          "该企业暂未开通店铺，如需开通，请联系客服020-22374967"
        )
      }
      this.props.history.push({
        pathname: path,
        state: { id: this.state.userInfo.companyId },
      })
    } else {
      this.startTaskEnterprise()
    }
  }

  /**
   * [checkStoreInfo 检查店铺]
   * @param  {[string|number]} companyId 企业id
   * @return null
   */
  private async checkStoreInfo(companyId: string | number) {
    const r = await request({
      url: `${config.MALLAPI}api/wshop/shop/info`,
      method: "post",
      data: {
        companyId,
      },
    })

    this.setState({
      isOpenStore: r.error_code === 0,
    })
  }

  private async checkLogin(callback: Function) {
    const r = await request({
      method: "get",
      url: `${config.WAPAPI}safety/account/get`,
      data: {
        queryType: 1,
      },
    })

    callback && callback(r)
  }
}
